/* Prop contracts for the /wheel surfaces so the parts can be built apart. */
import type { WheelPrize } from "@/lib/wheel/prizes"

/** Light layers on the headline slices. All on by default except as the page says. */
export interface WheelVfx {
  rays: boolean
  edge: boolean
  flares: boolean
  sparks: boolean
}

export const DEFAULT_VFX: WheelVfx = { rays: false, edge: false, flares: true, sparks: true }

export interface PrizeWheelProps {
  /** Which light layers the two headline slices draw. */
  vfx?: WheelVfx
  /** Segment to land on. null = idle. */
  targetIndex: number | null
  /** Bump to start a new spin at the same or a new target. */
  spinKey: number
  /** Fires once the wheel has come to rest on targetIndex. */
  onSettled: (segmentIndex: number) => void
  /** Sound on/off (ticks + landing). */
  sound: boolean
  /** Edge px; the wheel is square. Default fills its container. */
  size?: number
  className?: string
}

export type SpinPhase = "idle" | "spinning" | "settled" | "revealed" | "claimed"

export interface PrizeRevealProps {
  prize: WheelPrize | null
  phase: SpinPhase
  /** Grants the prize into the real stores. Owner flips phase to "claimed". */
  onClaim: () => void
  /** Share fired (any channel). Owner adds a spin. */
  onShared: () => void
  /** Reset for the next spin. */
  onDismiss: () => void
}
